export default {
  name: "GoCrazyControl"
}
